module.exports = __webpack_public_path__ + "f77951801afff53cffc18f0b02ff92ab.ttf";